import messages from '../../../../locale/messages';
import { inputTextLimit } from '../../../../helpers/fieldRestriction';

const validate = values => {
    const errors = {};

    if (!values.accountId) {
        errors.accountId = messages.required;
    } else if (values.accountId && values.accountId.toString().trim() == '') {
        errors.accountId = messages.required;
    } else if (values.accountId && values.accountId.length > inputTextLimit) {
        errors.accountId = messages.textAreaError;
    }

    // The stored secret is never returned to the browser. Blank keeps it.
    if (values.securityId && values.securityId.length > inputTextLimit) {
        errors.securityId = messages.textAreaError;
    }

    if (!values.phoneNumber) {
        errors.phoneNumber = messages.required;
    } else if (values.phoneNumber && values.phoneNumber.toString().trim() == '') {
        errors.phoneNumber = messages.required;
    } else if (values?.phoneNumber?.length > inputTextLimit) {
        errors.phoneNumber = messages.textAreaError;
    }

    return errors;
};

export default validate
